<template>
  <div>
    <div>
      <h3 style="margin-left:30px">基本信息：</h3>
      <div class="m_flex_row" style="margin-left:60px;margin-top:30px;">
        <div class="m_flex_column" style="width:100px;">姓名：</div>
        <a-input v-model="name" placeholder="请输入" allowClear style="width:500px" />
      </div>

      <div class="m_flex_row" style="margin-left:60px;margin-top:30px;">
        <div class="m_flex_column" style="width:100px;">手机号：</div>
        <a-input v-model="phone" placeholder="请输入" allowClear style="width:500px" />
      </div>

      <div class="m_flex_row" style="margin-left:60px;margin-top:30px;">
        <div class="m_flex_column" style="width:100px;">密码：</div>
        <a-input-password v-model="password" placeholder="请输入" allowClear style="width:500px" />
      </div>

      <div class="m_flex_row" style="margin-left:60px;margin-top:30px;">
        <div class="m_flex_column" style="width:100px;">性别：</div>
        <a-select v-model="sex" style="width: 120px" @change="handleChange">
          <a-select-option value="0">男</a-select-option>
          <a-select-option value="1">女</a-select-option>
          <a-select-option value="-1">未知</a-select-option>
        </a-select>
      </div>

      <div class="m_flex_row" style="margin-left:60px;margin-top:30px;">
        <div class="m_flex_column" style="width:100px;">权限/角色：</div>
        <a-select v-model="authority" style="width: 120px">
          <a-select-option value="100">超级管理员</a-select-option>
          <a-select-option value="200">项目管理员</a-select-option>
          <a-select-option value="300">医生</a-select-option>
          <a-select-option value="400">医生助理</a-select-option>
          <a-select-option value="500">患者</a-select-option>
        </a-select>
      </div>
      <a-button type="primary" @click="handleSubmit" style="margin-left:120px;margin-top:50px">保存</a-button>
    </div>
  </div>
</template>

<script>
import request from "../../utils/request";

export default {
  data() {
    return {
      phone: "",
      password: "",
      name: "",
      sex: "",
      authority: ""
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      let the_id = this.$route.query.the_id;
      if (the_id) {
        request({
          url: "/user/back/detail/" + the_id,
          method: "get",
          params: {}
        }).then(response => {
          console.log("获取到的参数", response.data);
          if (response.data.success) {
            let data = response.data.data;
            this.phone = data.phone;
            this.password = data.password;
            this.name = data.name;
            this.sex = data.sex+"";
            this.authority = data.authority+"";
          } else {
            this.$message.error(response.data.msg);
            this.$router.push({ path: "/user/manager/all" });
          }
        });
      }
    },
    handleSubmit() {
      let the_id = this.$route.query.the_id;
      if (the_id) {
        request({
          url: "/user/back/update",
          method: "POST",
          data: {
            update_user_id: the_id,
            phone: this.phone,
            password: this.password,
            name: this.name,
            sex: this.sex,
            authority: this.authority
          }
        }).then(response => {
          let data = response.data;
          if (data.success) {
            this.$message.success(data.msg);
            this.$router.push({ path: "/user/manager/all" });
          } else {
            this.$message.error(data.msg);
          }
          console.log(response);
        });
      } else {
        request({
          url: "/user/back/add/",
          method: "POST",
          data: {
            phone: this.phone,
            password: this.password,
            name: this.name,
            sex: this.sex,
            authority: this.authority
          }
        }).then(response => {
          let data = response.data;
          if (data.success) {
            this.$message.success(data.msg);
            this.$router.push({ path: "/user/manager/all" });
          } else {
            this.$message.error(data.msg);
          }
          console.log(response);
        });
      }
    }
  }
};
</script>
